var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "range-slider" }, [
    _c(
      "div",
      {
        staticClass: "range-slider--bars",
        attrs: { id: "range-bars-" + _vm.seed }
      },
      _vm._l(_vm.histogram, function(bar) {
        return _c(
          "div",
          {
            key: bar.id,
            style: { height: 100 * (bar.count / _vm.totalItems) + "%" }
          },
          [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm._f("money")(_vm.rangeMin(bar.start), {
                    minimumFractionDigits: 0
                  })
                )
              )
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm._f("money")(_vm.rangeMax(bar.end), {
                    minimumFractionDigits: 0
                  })
                )
              )
            ])
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", {
      staticClass: "js-range-slider",
      attrs: {
        "data-min": _vm.min,
        "data-max": _vm.max,
        "data-default": _vm.rangeDefault,
        "data-range-bars-selector": "#range-bars-" + _vm.seed
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "range-slider--values" }, [
      _c("span", [
        _vm._v(
          _vm._s(_vm._f("money")(_vm.selectedMin, { minimumFractionDigits: 0 }))
        )
      ]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          _vm._s(_vm._f("money")(_vm.selectedMax, { minimumFractionDigits: 0 }))
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }